import { Input } from '../input'

export default {
  name: 'KSelectSearch',
  props: {
    placeholder: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  data() {
    return {
      searchToken: '',
    }
  },
  computed: {},
  watch: {
    searchToken(value) {
      this.$emit('search', value)
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    handleKeyDown(e) {
      const keyCode = e.which
      this.$emit('keydown', keyCode)
    },
    clear() {
      this.searchToken = ''
    },
  },
  render() {
    const css = {
      'km-select__search': true,
      'km-select__search--has-footer': !!this.$slots.footer,
    }

    const data = {
      class: css,
    }

    const input = <Input
      ref="input"
      prefix={this.icon}
      placeholder={this.placeholder}
      class="km-select__search-input"
      clearable={true}
      vModel={this.searchToken}
      onKeydown={this.handleKeyDown}
    />

    return (
      <div {...data}>
        {
          this.$slots.footer
            ? <div class="km-select__search-input-wrapper">
              {input}
              {this.$slots.default}
            </div>
            : [input, this.$slots.default]
        }
        {
          this.$slots.footer
        }
      </div>
    )
  },
}
